<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  			<li class="m-nav__item">
		  				<router-link :to="{name: 'home'}">
		  					<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
		  					</span>
		  				</router-link>
		  			</li>
		  			<li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
                        <router-link :to="{name: 'adminControlPoints'}">
                        <span class="m-nav__link-text">
                            {{'control_points' | translate | titleize}}
                        </span>
                        </router-link>
		  			</li>
            <li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  				<span class="m-nav__link-text">
		  					{{'cameras_list' | translate | titleize}}
		  				</span>
		  			</li>
		  		</ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon">
                <i class="la la-camera-retro"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{'cameras' | translate | capitalize}}
              </h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
              <li class="m-portlet__nav-item">
                <a href="#" class="btn btn-success m-btn m-btn--icon" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#new_camera_modal" @click="setStatusCameraModal(true)">
							    <span>
                    <i class="fa fa-plus"></i>
                    <span>
                      {{'create_camera' | translate | capitalize }}
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-portlet__body">
         <div class="form-group m-form__group row">
           <div class="col-lg-3">
              <label for="control_point">{{ 'control_point' | translate | capitalize }}</label>
              <select v-model="control_point" name="type" id="type" class="form-control m_selectpicker" :title="'select_control_point' | translate | capitalize">
                <option v-for="cp in control_points" :key="cp.id" :value="cp.id">{{ cp.name | translate | capitalize }}</option>
              </select>
            </div>
          </div>
          <s-datatable :config="datatable">
            <div slot="state" slot-scope="props">
              <a @click="cameraStatus(props.row.id, props.row.state == 1 ? 0 : 1)">
                <span v-tooltip="messageStateTooltip" v-if="props.row.state == 1" class="m-badge m-badge--success m-badge--wide">{{'active' | translate | capitalize}}</span>
                <span v-tooltip="messageStateTooltip" v-else class="m-badge m-badge--danger m-badge--wide">{{'inactive' | translate | capitalize}}</span>
              </a>
            </div>
            <div slot="actions" slot-scope="props">
              <a v-tooltip="messageEditTooltip" href="#" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit"  data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#new_camera_modal" @click="editCamera(props.row)">
                <i class="la la-edit"></i>
              </a>
              <a v-tooltip="messageTestTooltip" href="#" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit"  data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#test_camera_modal" @click="testCam(props.row)">
                <i class="la la-camera"></i>
              </a>
            </div>
          </s-datatable>
        </div>
        <s-modal id="new_camera_modal" :title="edit ? 'edit_camera' : 'create_camera' | translate | capitalize">
          <s-new-camera :data_send="data_modal" slot="body"></s-new-camera>
        </s-modal>
        <s-modal id="test_camera_modal" :title="'view_camera' | translate | capitalize">
          <s-test-camera :data_send="test_data_modal" slot="body"></s-test-camera>
        </s-modal>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SModal from '@/components/layout/modal/Modal.vue'
import SDatatable from '@/components/layout/datatable/Datatable.vue'
import SNewCamera from '@/components/admin/cameras/NewCamera.vue'
import STestCamera from '@/components/admin/cameras/TestCamera.vue'
import swal from 'sweetalert'
export default {
  components: { SDatatable, SModal, SNewCamera, STestCamera },
  data () {
    return {
      control_point: '',
      control_points: [],
      datatable: {},
      messageStateTooltip: this.$options.filters.capitalize('camera_state'),
      messageEditTooltip: this.$options.filters.capitalize('edit_record'),
      messageTestTooltip: this.$options.filters.capitalize('test_camera'),
      level: '',
      data_modal: {},
      test_data_modal: {},
      edit: false
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusCameraModal', permissions: 'getUserPermissions', shard: 'getUserShard'})
  },
  created () {
    this.retriveControlPoints()
      .then((response) => {
        if (response.data) {
          this.control_points = response.data
          this.control_points.unshift({id: 0, name: 'all'})
        }
      })
      .catch((error) => {
        resolve(error)
      })
  },
  mounted () {
    this.control_point = this.$route.params.control_point
    if (!this.control_point) {
      this.control_point = 0
    }
    const self = this
    const datatable = {
      url: '/api/camera/list',
      method: 'POST',
      size: 15,
      columns: [
        {
          field: 'name',
          title: 'name'
        },
        {
          field: 'ip_address',
          title: 'ip_address'
        },
        {
          field: 'manufacturer_name',
          title: 'manufacturer'
        },
        {
          field: 'control_point_name',
          title: 'control_point'
        },
        {
          field: 'reference',
          title: 'reference'
        },
        {
          field: 'mode',
          title: 'mode',
          template: function (row) {
            return self.$options.filters.capitalize(row.mode)
          }
        }],
      actions: true,
      state: true,
      update: false,
      query: { control_point_id: this.control_point }
    }
    this.datatable = datatable
  },
  methods: {
    ...mapActions([ 'retriveControlPoints', 'setStatusCameraModal', 'setStatusTestCameraModal', 'inactivateCamera' ]),
    validPermission (code) {
      return this.permissions.find(p => { return (p.code === code) }) !== undefined
    },
    focusComponent () {

    },
    cameraStatus (camera, state) {
      var msgTitle = this.$options.filters.capitalize('confirm_status_title')
      var msgText = this.$options.filters.capitalize('confirm_status_text')
      swal({
        title: msgTitle,
        text: msgText,
        icon: 'warning',
        dangerMode: true,
        buttons: {
          cancel: this.$options.filters.capitalize('cancel'),
          accept: {
            text: this.$options.filters.capitalize('accept'),
            willDelete: 'accept',
            closeModal: true
          }
        }
      }).then(willDelete => {
        if (willDelete) {
          let cam = { id: camera, state: state }
          this.inactivateCamera(cam)
            .then((res) => {
              this.datatable.update = true
              this.$spinner.remove()
              if (res.status === 200) {
                this.$toast('status_camera_message')
              }
            }).catch((err) => {
              this.$toast('status_camera_error', 4)
              this.$spinner.remove()
              console.log(err)
            })
        }
      })
      this.$spinner.remove()
    },
    editCamera (camera) {
      this.data_modal = camera
      this.setStatusCameraModal(true)
      this.edit = true
    },
    testCam (camera) {
      this.test_data_modal = camera
      this.setStatusTestCameraModal(true)
    }
  },
  watch: {
    modal (newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.datatable.update = true
        this.data_modal = {}
        this.edit = false
      }
    },
    control_point (newVal, oldVal) {
      this.datatable.query = { control_point_id: this.control_point }
      this.datatable.update = true
    }
  }
}
</script>
<style>
.swal-button.swal-button--cancel {
    color: #555;
    background-color: #efefef;
    font-size: 12px;
    border: 1px solid #3e549a;
    text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
    border-radius: 2px;
}
.swal-button.swal-button--accept {
  border-radius: 2px;
  background-color: #D21717;
  font-size: 12px;
  border: 1px solid #3e549a;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// Camera.vue